import { useState } from "react";
import { CreditCard, Bitcoin, Banknote, Lock, Loader2 } from "lucide-react";
import { money } from "@/lib/api";

const METHODS = [
  { id: "card", label: "Card", icon: CreditCard, hint: "Visa, Mastercard, Amex · processed by Stripe" },
  { id: "crypto", label: "Crypto", icon: Bitcoin, hint: "USDC stablecoin via Stripe · settles in USD" },
  { id: "cash", label: "Cash", icon: Banknote, hint: "Pay in person · your partner confirms receipt" },
];

export function PaymentMethodPicker({ total, amount, busy, onPay }) {
  const [m, setM] = useState("card");
  const [note, setNote] = useState("");
  const isCash = m === "cash";
  return (
    <div data-testid="payment-method-picker">
      <div className="grid grid-cols-3 gap-2" role="radiogroup" aria-label="Payment method">
        {METHODS.map(({ id, label, icon: I }) => (
          <button key={id} type="button" role="radio" aria-checked={m === id} onClick={() => setM(id)}
            className={`flex flex-col items-center gap-2 rounded-2xl border px-3 py-4 text-sm transition-colors ${m === id ? "border-[#E0218A] bg-[#E0218A]/10 text-[#8E2BC4]" : "border-[#2A1240]/10 text-slate-300 hover:border-[#2A1240]/30"}`}
            data-testid={`pay-method-${id}`}>
            <I className="h-5 w-5" />{label}
          </button>
        ))}
      </div>
      <p className="mt-3 text-xs text-slate-400" data-testid="pay-method-hint">{METHODS.find((x) => x.id === m).hint}</p>
      {isCash && (
        <textarea rows={2} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Optional note, e.g. paid at the venue on 12 Nov"
          className="field mt-3" data-testid="pay-cash-note" />
      )}
      <button className="btn-gold w-full mt-5 !py-4" disabled={busy} onClick={() => onPay(m, note)} data-testid="pay-submit-button">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : isCash ? <Banknote className="h-4 w-4" /> : <Lock className="h-4 w-4" />}
        {busy ? "Working…" : isCash ? `I paid ${money(amount, 2)} in cash` : `Pay ${money(total, 2)} by ${m === "crypto" ? "crypto" : "card"}`}
      </button>
      {isCash && <p className="mt-2 text-[11px] text-slate-400 text-center">No transaction fee on cash. The receipt is issued once your partner confirms they received it.</p>}
    </div>
  );
}
